import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function TestimonialSection() {
  return <Section className="bg-partyPink-light" data-id="element-201">
      <div className="max-w-md mx-auto" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="bg-white rounded-3xl overflow-hidden shadow-lg" data-id="element-203">
          {/* Image */}
          <div className="w-full aspect-[4/3] overflow-hidden" data-id="element-204">
            <img src="https://cdn.magicpatterns.com/uploads/5rtXvzSrgj3KxeUycMi7r7/20260409_1251_Image_Generation_remix_01knrxvzj1f1krhnhzw7h1a5t6.png" alt="Mamá feliz en fiesta decorada con el kit" className="w-full h-full object-cover" data-id="element-205" />
          </div>

          {/* Text content */}
          <div className="p-6 md:p-8" data-id="element-206">
            <h3 className="text-xl md:text-2xl font-black text-gray-800 mb-4" data-id="element-207">
              No lo decimos nosotros, lo dicen ellas 🎉
            </h3>
            <p className="text-gray-600 font-medium leading-relaxed mb-5 italic" data-id="element-208">
              "Siempre pensé que organizar una fiesta bonita era carísimo y
              complicado… con este kit lo hice todo yo sola en una tarde. Mi
              hija no paraba de decir que era la mejor fiesta del mundo. ¡Hasta
              las otras mamás me preguntaron dónde lo había comprado!"
            </p>
            <p className="font-bold text-gray-800" data-id="element-209">
              - Patricia R., mamá de Valentina
            </p>
          </div>
        </motion.div>
      </div>
    </Section>;
}